module.exports = __webpack_public_path__ + "static/media/thumb-down.cbb7daaa.svg";